import React from 'react'
import { Breadcrumb,  } from 'antd'
import {  HomeIcon, DocumentChartBarIcon  } from "@heroicons/react/16/solid";
import LeaveSummary from './LeaveSummary';
//import LeaveTable from './LeaveTable';
const LeavesDetails = () => {
  const items = [
    
    {
      href: '/',
      title: (
        <span className='flex sm:gap-2 items-center'>
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className='text-gray-400 sm:text-lg'>Home</span>
        </span>
      ),
    },
    {
      href: '/leavedetail',
      title: (
        <span className='flex sm:gap-2 items-center'>
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className='text-gray-400 sm:text-lg'> Leave Details</span>
        </span>
      ),
    },
  ]
  return (
    <div>
      <span className='flex py-4 px-2 sm:p-10 flex-wrap gap-4 justify-between items-center '>
        <span className='flex flex-col gap-2 text-2xl  md:text-4xl font-black  '>
         Leaves Summary
          <Breadcrumb items={items} />
        </span>
      </span>
     <LeaveSummary/>
      {/* <LeaveTable /> */}
    </div>

  )
}

export default LeavesDetails 